import { RequiredTranslationsTemplate } from '.'

const ro: RequiredTranslationsTemplate = {
  meta: {
    localeName: 'Română',
  },
  home: {
    title: 'RECHEMARE PRODUS - ROCKRIDER XC500S',
    description:
      'Vă mulțumim pentru că ați achiziționat bicicleta ROCKRIDER XC500S (MTB). Am identificat un defect potențial la furca frontală. Doar anumite biciclete sunt defecte. Vă rugăm să introduceți cele 30 de cifre din numărul de trasabilitate a bicicletei dvs. pentru a confirma dacă bicicleta dvs. este afectată de această rechemare:',
    form: {
      title: 'Vă rugăm să furnizați următoarele informații:',
      fields: {
        serialNumber: 'Număr trasabilitate bicicletă:',
        serialNumberFamily: 'N° série (début)',
        firstName: 'Prenume',
        lastName: 'Nume de familie',
        email: 'E-mail',
        phone: 'Telefon',
        country: 'Țară',
        submit: 'Validator',
        choose: 'Alege...',
      },
      errors: {
        requiredField: 'Acest câmp este obligatoriu',
        unknownSerialNumber: 'Număr de serie necunoscut',
        provide6Numbers: 'Vă rugăm să rețineți că sunt necesare 6 cifre',
      },
      confirmations: {
        good: {
          title: 'Bicicleta dvs. nu este afectată',
          p1: 'Vă informăm că bicicleta dvs. nu este afectată de această rechemare. Vă rugăm să continuați să vă bucurați de plimbatul cu bicicleta.',
          p2: 'Ne cerem scuze pentru orice inconveniențe cauzate,',
          p3: 'Cu stimă,',
          p4: 'Echipa Decathlon',
        },
        defective: {
          title: 'Bicicleta dvs. este din nefericire afectată.',
          p1: 'Vă rugăm să opriți imediat utilizarea acestei biciclete și să contactați cel mai apropiat Magazin Decathlon pentru a înlocui furca.',
          p2: 'Vă rugăm să rețineți că este posibil să nu puteți utiliza bicicleta câteva zile pe durata reparației. Puteți fi liniștiți că vom depune toate eforturile pentru a minimiza aceste întârzieri. Vă recomandăm să vă consultați direct cu atelierul din Magazinul Decathlon ales pentru a primi o estimare a timpului de reparație.',
          p3: 'Pentru a găsi cel mai apropiat Atelier Decathlon:',
          decathlonLocatorLink: 'https://www.decathlon.fr/store-locator',
          p4: 'Veți găsi mai jos „Notificarea de retur client” pentru a o prezenta Tehnicianului nostru când returnați bicicleta la atelier:',
          p5: 'Pentru mai multe informații, vă rugăm să ne contactați la numarul de telefon 021 408 5005 de Luni-Vineri 09h00 la 20h00 și Sâmbăta-Duminica 10h00 la 19h00',
        },
      },
    },
    findTheSerialNumber: {
      title: 'Cum găsiți numărul de trasabilitate a bicicletei:',
      description:
        'Numărul din 30 de cifre este imprimat sub cadrul bicicletei dvs., în apropierea axului pedalier și a pedalelor. Vedeți imaginea de mai jos.',
    },
  },
}

export default ro
